var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchIconBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "#002240",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6004 13.1802L11.1304 9.71018C12.6304 7.54018 12.4204 4.55018 10.4904 2.62018C8.32043 0.450176 4.80043 0.450176 2.63043 2.62018C0.46043 4.79018 0.46043 8.31017 2.63043 10.4802C4.56043 12.4102 7.55043 12.6102 9.72043 11.1202L13.1904 14.5902C13.5804 14.9802 14.2104 14.9802 14.6004 14.5902C14.9904 14.2102 14.9904 13.5702 14.6004 13.1802ZM4.04043 9.08018C2.65043 7.69018 2.65043 5.43018 4.04043 4.04018C5.43043 2.65018 7.69043 2.65018 9.08043 4.04018C10.4704 5.43018 10.4704 7.69018 9.08043 9.08018C7.69043 10.4702 5.43043 10.4702 4.04043 9.08018Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIconBlack);
export default __webpack_public_path__ + "static/media/search-icon-black.9ae2d8f8e115b39313a4c0bb8d168e48.svg";
export { ForwardRef as ReactComponent };